
export enum BallotType {
    CIB = 1,
    IEC = 2,
    NPB = 3, // National Project Ballot (SD)
    SR = 4,
}
